export default {
  app: {
    tradeOffers: {
      country: '国',
      loginPrompt: 'トレードオファーを確認するには{0}してください',
      logIn: 'ログイン',
    },
  },
};
